export const baseUrl = 'https://fuurin-paint-workshop.web.app/';
